import { render } from "./AppHeader.vue?vue&type=template&id=3d45385c&bindings={\"list\":\"data\",\"isLoggedIn\":\"options\",\"logout\":\"options\",\"openLogin\":\"options\"}"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"
script.render = render

export default script